import { render, staticRenderFns } from "./TabsManager.vue?vue&type=template&id=1b06a5ba&"
import script from "./TabsManager.vue?vue&type=script&lang=js&"
export * from "./TabsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports